const styles = theme => ({
  toolBarRootPage: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing.unit * 5
  },
  actionWrapper: {
    alignItems: 'center',
    display: 'flex',
    flex: 1
  },
  contentOptions: {
    alignItems: 'center',
    display: 'flex',
    height: 24
  },
  actions: {
    flex: 1,
    justifyContent: 'flex-end',
    display: 'flex'
  },
  buttonsRoot: {
    padding: 0
  },
  filterOptionsWrapper: {
    height: 88,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FFF',
    borderRadius: '2px',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)',
    marginBottom: theme.spacing.unit * 2,
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3
  },
  exception: {
    fontWeight: 'bold',
    color: '#F22D12'
  },
  activateToggleLabel: {
    fontSize: '16px',
    lineHeight: '24px'
  },
  titleWrapper: {
    position: 'relative'
  }
});

export default styles;
